import FormInput from '@/components/Form/FormInput';
import { MOBILE_REG } from '@lhb/regexp';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import VerificationInput from './VerificationInput';
import { Form } from 'antd';
import { get } from '@/common/request';
import { FormInstance } from 'antd/es/form/Form';
import { IconFont } from '@/components';
import styles from '../index.module.less';

const { Item } = Form;

interface PasswordAccountFormProps {
  form?: FormInstance
}


const PasswordAccountForm: FC<PasswordAccountFormProps> = (props) => {
  const { form } = props;
  const [mobile, setMobile] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(true);
  const [isStart, setIsStart] = useState<boolean>(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { value } = target;
    setMobile(value as string);
  };

  const onSend = async() => {
    if (!form) {
      return;
    }

    // await form.validateFields();
    const data = await get('/sendCode', { mobile }, {
      proxyApi: '/mirage', // 指向lcn 接口的代理
      needHint: true
    }).catch(() => {
      setIsStart(false);
    });
    if (data) {
      window.microMessage.success('短信发送成功');
      setIsStart(true);
    }
  };

  useEffect(() => {
    if (mobile) {
      setDisabled(false);
      return;
    }
    setDisabled(true);
  }, [mobile]);

  const onStart = () => {
    setIsStart(false);
  };


  return (
    <>
      <FormInput
        name='mobile'
        rules={[
          { required: true, message: '请输入11位手机号码'
          },
          { pattern: MOBILE_REG, message: '输入的手机号码不合法' }
        ]}
        placeholder='请输入手机号'
        prefix={<IconFont iconHref='res-servise-ic_phone' className={styles.icon}/>}
        maxLength={11}
        config={{
          value: mobile,
          onChange: onChange,
          size: 'large'
        }}
      />
      <Item name='code' rules={
        [
          { required: true, message: '验证码不能为空' },
          { max: 6, message: '验证码最多6位' }
        ]
      }>
        <VerificationInput
          onClick={onSend}
          onStart={onStart}
          disable={disabled}
          isStart={isStart}
          size='large'/>
      </Item>
    </>
  );
};


export default PasswordAccountForm;
